import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import elementsIds from '@/const/elementIds.json';
import { useOsService } from '@/services/OsService/OsService';
import AgentActionMenuWindows from './AgentTable/components/AgentActionMenu/OS/AgentActionMenu.windows.vue';
import AgentActionMenuLinux from './AgentTable/components/AgentActionMenu/OS/AgentActionMenu.linux.vue';
import { SelectedAgent } from './AgentActionMenu.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentActionMenu',
  props: {
    beforeHide: null,
    agent: null,
    contextMenu: { type: Boolean }
  },
  setup(__props: any) {

const osService = useOsService();


return (_ctx: any,_cache: any) => {
  return (_unref(osService)?.isWindows.value)
    ? (_openBlock(), _createBlock(AgentActionMenuWindows, {
        key: 0,
        "data-testid": _unref(elementsIds).agents.AgentsActionMenuList.listWindows,
        agent: __props.agent,
        "before-hide": __props.beforeHide,
        "context-menu": __props.contextMenu
      }, null, 8, ["data-testid", "agent", "before-hide", "context-menu"]))
    : (_unref(osService)?.isUnix.value)
      ? (_openBlock(), _createBlock(AgentActionMenuLinux, {
          key: 1,
          "data-testid": _unref(elementsIds).agents.AgentsActionMenuList.listLinux,
          agent: __props.agent,
          "before-hide": __props.beforeHide,
          "context-menu": __props.contextMenu
        }, null, 8, ["data-testid", "agent", "before-hide", "context-menu"]))
      : _createCommentVNode("", true)
}
}

})